/**
 * Shepard tone math (pure): K octave-spaced partials whose positions cycle through [0, K) octaves and whose
 * gains follow a Gaussian over log-frequency, zero at both edges so wrap-around is silent.
 */
export function shepardGain(position: number, octaves: number): number {
  const c = octaves / 2;
  const sigma = octaves / 4.5;
  const g = Math.exp(-((position - c) * (position - c)) / (2 * sigma * sigma));
  const edge = Math.exp(-(c * c) / (2 * sigma * sigma));
  return Math.max(0, (g - edge) / (1 - edge));
}

/** Position (octaves above the lowest partial) of partial i at cycle phase (0..1). */
export function shepardPosition(i: number, phase: number, octaves: number): number {
  const p = (i + phase * octaves) % octaves;
  return p < 0 ? p + octaves : p;
}

/** Frequencies and gains for all partials at a cycle phase, centred on `centerHz`. */
export function shepardState(centerHz: number, phase: number, octaves: number): { hz: number[]; gain: number[] } {
  const lowHz = centerHz / Math.pow(2, octaves / 2);
  const hz: number[] = [];
  const gain: number[] = [];
  for (let i = 0; i < octaves; i++) {
    const p = shepardPosition(i, phase, octaves);
    hz.push(lowHz * Math.pow(2, p));
    gain.push(shepardGain(p, octaves));
  }
  return { hz, gain };
}
